import React from 'react';
import styled from 'styled-components';
import print_btn from './ic_print.svg';
import { IHomeReportDiscountResData } from 'features/user/services/types/discount';
import { formatCurrency } from 'utils/formatCurrency';
import { Spin } from 'antd';
type Props = {
  loading?: boolean;
  data?: IHomeReportDiscountResData | null;
  onPrint?: () => void;
};
const HomeDiscountPopoverContent = ({ loading, data, onPrint }: Props) => {
  return (
    <Spin spinning={loading}>
      <Container>
        <Head>
          <span className="title">DISCOUNT</span>
          <button className="btn-print" type='button' onClick={(e: any) => [e.stopPropagation(), e.preventDefault(), onPrint?.()]}><img src={print_btn} alt="print_btn" /></button>
        </Head>
        <Body>
          <div className="row-item">
            <span className="label">Staff discount:</span>
            <span className="value">{formatCurrency(data?.staffDiscount)}</span>
          </div>
          <div className="row-item">
            <span className="label">owner discount:</span>
            <span className="value">{formatCurrency(data?.ownerDiscount)}</span>
          </div>
          <div className="row-item">
            <span className="label">total discount:</span>
            <span className="value">{formatCurrency(data?.totalDiscount)}</span>
          </div>
        </Body>
      </Container>
    </Spin>
  );
};

export default HomeDiscountPopoverContent;

const Container = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
border-radius: 8px;
background: #FFF;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
width: 320px;
`;

const Head = styled.div`
display: flex;
padding: 16px 8px;
justify-content: space-between;
align-items: center;
align-self: stretch;
border-bottom: 1px solid #E9EDF2;
background: #F6F7FC;
  span.title {
    color: #346751;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  .btn-print {
    display: flex;
    width: 50px;
    height: 50px;
    padding: 16px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    aspect-ratio: 1/1;
    border-radius: 4px;
    border: 1px solid #2D6772;
    background: #FFF;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #144B55 inset;

    &:active {
      opacity: 0.5;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
`;

const Body = styled.div`
  display: flex;
  padding: 0 16px 24px 16px;
  flex-direction: column;
  align-self: stretch;
  align-items: flex-start;
  border: 0 solid #E5E7EB;
  background: rgba(0, 0, 0, 0.00);

  .row-item {
    display: flex;
    height: 48px;
    padding: 6px 0;
    align-items: center;
    align-self: stretch;
    gap: 16px;
    span.label {
      color: #505050;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: uppercase;
      flex: 1;
    }

    span.value {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      color: #1D2129;
      text-align: right;
      text-overflow: ellipsis;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 166.667% */
      text-transform: capitalize;
    }
  }  
`;